
<template>
  <div></div>
</template>

<script>
    import { EventBus } from '@/event-bus.js';
  export default {
    name: 'MdTextSpeech',
    props: {
      
    },
    data() {
      return {
        isSpeechRecognitionSupported: false,
        recognition: null,
        recognizing : false,
        isSpeaking: false,
        replacements: {
            'es': [
                // Puntuación básica
                { regex: /\bpunto y coma\b/gi, value: ';' },
                { regex: /\bpunto\b/gi, value: '.' },
                { regex: /\bcoma\b/gi, value: ',' },
                { regex: /\bdos puntos\b/gi, value: ':' },
                
                // Comillas - mejorado con variantes
                { regex: /\bcomillas\b/gi, value: '"' },
                { regex: /\babrir comillas\b/gi, value: '"' },
                { regex: /\bcerrar comillas\b/gi, value: '"' },
                { regex: /\bcomilla\b/gi, value: '"' },
                { regex: /\babrir comilla\b/gi, value: '"' },
                { regex: /\bcerrar comilla\b/gi, value: '"' },
                
                // Paréntesis - mejorado
                { regex: /\bparéntesis\b/gi, value: ')' },
                { regex: /\babrir paréntesis\b/gi, value: '(' },
                { regex: /\bcerrar paréntesis\b/gi, value: ')' },
                { regex: /\bparentesis\b/gi, value: ')' },
                { regex: /\babrir parentesis\b/gi, value: '(' },
                { regex: /\bcerrar parentesis\b/gi, value: ')' },
                
                // Guiones y símbolos
                { regex: /\bguion\b/gi, value: '-' },
                { regex: /\bguión\b/gi, value: '-' },
                { regex: /\bguion bajo\b/gi, value: '_' },
                { regex: /\bguión bajo\b/gi, value: '_' },
                { regex: /\braya\b/gi, value: '-' },
                
                // Signos de interrogación y exclamación
                { regex: /\binterrogación\b/gi, value: '?' },
                { regex: /\bsigno de interrogación\b/gi, value: '?' },
                { regex: /\bexclamación\b/gi, value: '!' },
                { regex: /\bsigno de exclamación\b/gi, value: '!' },
                { regex: /\bsigno interrogación\b/gi, value: '?' },
                { regex: /\bsigno exclamación\b/gi, value: '!' },
                
                // Saltos de línea y párrafo
                { regex: /\bnueva línea\b/gi, value: '\n' },
                { regex: /\bnuevo renglón\b/gi, value: '\n' },
                { regex: /\benter\b/gi, value: '\n' },
                { regex: /\bnuevo párrafo\b/gi, value: '\n\n' },
                { regex: /\bpárrafo nuevo\b/gi, value: '\n\n' },
                
                // Símbolos adicionales
                { regex: /\bpor ciento\b/gi, value: '%' },
                { regex: /\bporciento\b/gi, value: '%' },
                { regex: /\banderscore\b/gi, value: '_' }
            ],
            'en': [
                // Basic punctuation
                { regex: /\bsemicolon\b/gi, value: ';' },
                { regex: /\bperiod\b/gi, value: '.' },
                { regex: /\bcomma\b/gi, value: ',' },
                { regex: /\bcolon\b/gi, value: ':' },
                
                // Quotes - enhanced
                { regex: /\bquote\b/gi, value: '"' },
                { regex: /\bquotation marks?\b/gi, value: '"' },
                { regex: /\bopen quote\b/gi, value: '"' },
                { regex: /\bclose quote\b/gi, value: '"' },
                { regex: /\bdouble quote\b/gi, value: '"' },
                
                // Parentheses - enhanced
                { regex: /\bparenthesis\b/gi, value: ')' },
                { regex: /\bopen parenthesis\b/gi, value: '(' },
                { regex: /\bclose parenthesis\b/gi, value: ')' },
                { regex: /\bparen\b/gi, value: ')' },
                { regex: /\bopen paren\b/gi, value: '(' },
                { regex: /\bclose paren\b/gi, value: ')' },
                
                // Dashes and symbols
                { regex: /\bdash\b/gi, value: '-' },
                { regex: /\bhyphen\b/gi, value: '-' },
                { regex: /\bunderscore\b/gi, value: '_' },
                { regex: /\bunder score\b/gi, value: '_' },
                
                // Question and exclamation marks
                { regex: /\bquestion mark\b/gi, value: '?' },
                { regex: /\bexclamation mark\b/gi, value: '!' },
                { regex: /\bquestion\b/gi, value: '?' },
                { regex: /\bexclamation\b/gi, value: '!' },
                
                // Line and paragraph breaks
                { regex: /\bnew line\b/gi, value: '\n' },
                { regex: /\bnewline\b/gi, value: '\n' },
                { regex: /\bline break\b/gi, value: '\n' },
                { regex: /\bnew paragraph\b/gi, value: '\n\n' },
                { regex: /\bparagraph break\b/gi, value: '\n\n' },
                
                // Additional symbols
                { regex: /\bpercent\b/gi, value: '%' },
                { regex: /\bpercentage\b/gi, value: '%' },
                { regex: /\basterisk\b/gi, value: '*' },
                { regex: /\bstar\b/gi, value: '*' }
            ],
            'ar': [
                // علامات الترقيم الأساسية - Punctuation básica
                { regex: /فاصلة منقوطة/gi, value: ';' },
                { regex: /نقطة/gi, value: '.' },
                { regex: /فاصلة/gi, value: ',' },
                { regex: /نقطتان/gi, value: ':' },
                { regex: /نقطتين/gi, value: ':' }, // Variante común
                
                // الاقتباس - Comillas (mejorado)
                { regex: /اقتباس/gi, value: '"' },
                { regex: /علامة اقتباس/gi, value: '"' },
                { regex: /علامات اقتباس/gi, value: '"' },
                { regex: /فتح اقتباس/gi, value: '"' },
                { regex: /إغلاق اقتباس/gi, value: '"' },
                { regex: /شولة/gi, value: '"' }, // Término coloquial
                { regex: /علامة تنصيص/gi, value: '"' }, // Variante
                
                // الأقواس - Paréntesis (mejorado)
                { regex: /قوس/gi, value: ')' },
                { regex: /قوسين/gi, value: ')' }, // Plural común
                { regex: /فتح قوس/gi, value: '(' },
                { regex: /إغلاق قوس/gi, value: ')' },
                { regex: /قوس مفتوح/gi, value: '(' },
                { regex: /قوس مغلق/gi, value: ')' },
                
                // الشرطات والرموز - Guiones y símbolos
                { regex: /شرطة/gi, value: '-' },
                { regex: /شَرطَة/gi, value: '-' }, // Con diacríticos
                { regex: /وصلة/gi, value: '-' },
                { regex: /وَصْلَة/gi, value: '-' }, // Con diacríticos
                { regex: /شرطة سفلية/gi, value: '_' },
                { regex: /شَرطَة سُفْلِيَّة/gi, value: '_' }, // Con diacríticos
                { regex: /أندر سكور/gi, value: '_' }, // Transliteración
                
                // علامات الاستفهام والتعجب - Signos de interrogación y exclamación
                { regex: /علامة استفهام/gi, value: '?' },
                { regex: /عَلامَة اِسْتِفْهَام/gi, value: '?' }, // Con diacríticos
                { regex: /استفهام/gi, value: '?' },
                { regex: /علامة تعجب/gi, value: '!' },
                { regex: /عَلامَة تَعَجُّب/gi, value: '!' }, // Con diacríticos
                { regex: /تعجب/gi, value: '!' },
                
                // الأسطر والفقرات - Saltos de línea y párrafo
                { regex: /سطر جديد/gi, value: '\n' },
                { regex: /سَطْر جَدِيد/gi, value: '\n' }, // Con diacríticos
                { regex: /خط جديد/gi, value: '\n' }, // Variante
                { regex: /انتر/gi, value: '\n' }, // Transliteración de "Enter"
                { regex: /فقرة جديدة/gi, value: '\n\n' },
                { regex: /فَقْرَة جَدِيدَة/gi, value: '\n\n' }, // Con diacríticos
                
                // رموز إضافية - Símbolos adicionales
                { regex: /بالقيمة/gi, value: '%' }, // "Percent" comúnmente dicho
                { regex: /في المائة/gi, value: '%' },
                { regex: /بالمئة/gi, value: '%' },
                { regex: /نسبة/gi, value: '%' },
                { regex: /نجمة/gi, value: '*' },
                { regex: /كوكبة/gi, value: '*' }, // Variante
                { regex: /محولة/gi, value: '\\' }, // "Backslash"
                { regex: /شريط مائل/gi, value: '/' }
            ]
        },
        speechRecognitionList: null,

      }
    },
    methods:{
        // Check if the browser supports Speech Recognition
        // and initialize the recognition object
        SpeechRecognition(){
            this.isSpeechRecognitionSupported = 'SpeechRecognition' in window || 'webkitSpeechRecognition' in window;
            if(this.isSpeechRecognitionSupported){
                window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
                this.recognition = new window.SpeechRecognition();

                const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;
                // Gramáticas para cada idioma
                const grammarEs = `#JSGF V1.0;grammar puntuacion;public <command> = punto y coma |punto |coma |dos puntos |
                                    comillas | abrir comillas | cerrar comillas | paréntesis | abrir paréntesis |
                                    cerrar paréntesis | guion | guion bajo | interrogación | signo de interrogación |
                                    exclamación | signo de exclamación | nueva línea | nuevo párrafo ;`;

                const grammarEn = `#JSGF V1.0; grammar punctuation; public <command> = semicolon |
                                    period | comma | colon | quote | quotation marks | open quote | close quote |
                                    parenthesis | open parenthesis | close parenthesis | dash | hyphen |underscore |
                                    question mark | exclamation mark | new line | new paragraph ;`;
                
                const grammarAr = `#JSGF V1.0; grammar punctuation; public <command> = فاصلة منقوطة |
                                    نقطة | فاصلة | نقطتان | اقتباس | علامات اقتباس | فتح اقتباس | إغلاق اقتباس |
                                    قوس | فتح قوس | إغلاق قوس | شرطة | واصلة | شرطة سفلية |
                                    علامة استفهام | علامة تعجب | سطر جديد | فقرة جديدة ;`;
              
                // Selección de gramática según idioma
                let lang =  this.$root.$options.i18n.locale
                let grammar;
        
                switch(lang) {
                    case 'es':
                        grammar = grammarEs;
                        break;
                    case 'ar':
                        grammar = grammarAr;
                        break;
                    default:
                        grammar = grammarEn;
                }

                this.speechRecognitionList = new SpeechGrammarList();
                this.speechRecognitionList.addFromString(grammar, 1);

                /// Asignar gramática y lenguaje
                this.recognition.grammars = this.speechRecognitionList;

            }
        },
        // Toggle the speech bar visibility
        toggleSpeechBar() {
            var speechBar = document.getElementById('speechBar');
            if(speechBar.classList.contains("active")){
                speechBar.classList.remove('active');
            } else {
                speechBar.classList.add('active');
            }
        },
        // Stop the speech to text recognition
        stopSpeechToText() {
            this.toggleSpeechBar()
            this.recognition.stop();
            this.recognizing = false;
            this.isSpeaking = false;
        },
        // Start the speech to text recognition
        startSpeechToText(control) {
            // Stop voice reconigtion if is on
            if( this.isSpeaking ) this.stopSpeech();

            if(this.isSpeechRecognitionSupported) {
                this.recognition.lang = this.$root.$options.i18n.locale;
                this.recognition.continuous = true;
                this.recognition.interimResults = true;
                this.recognition.maxAlternatives = 1;
                this.recognition.onend = () => {
                    if(this.recognizing) {
                        this.toggleSpeechBar()
                    }
                    this.recognizing = false;
                    this.isSpeaking = false;
                };
                this.recognition.onerror = (event) => {
                    console.error('Speech recognition error detected: ' + event.error);
                    this.recognizing = false;
                    this.isSpeaking = false;
                    this.toggleSpeechBar()
                };
                this.recognition.onresult = (event) => {
                    if (typeof event.results === "undefined") {
                        this.recognizing = false;
                        this.recognition.stop();
                        return;
                    }
                    var changed = {
                        "ControlId":control,
                        "finalSentence":''
                    }
                    
                    for (var i = event.resultIndex; i < event.results.length; ++i) {
                        if (event.results[i].isFinal) {
                            changed = {
                                "ControlId":control,
                                "finalSentence":event.results[i][0].transcript
                            }
                            changed.finalSentence = this.speechReplaceSpecialCharsAndCommands(changed.finalSentence)
                            changed.finalSentence = this.capitalizeAfterPunctuation(changed.finalSentence)
                            // Emit the event with the final sentence
                            EventBus.$emit('receivedS2T', changed);
                        }
                    }
                };
                if (!this.recognizing) {
                    this.recognition.start();
                    this.recognizing = true;
                } else {
                    this.recognition.stop();
                    this.recognizing = false;
                    this.isSpeaking = false;
                }
            }
        },

        // Start the speech synthesis
        startSpeech(speech) {
            console.log('speech', speech);
            if( speech.length > 0 ) {
                
                // Stop voice reconigtion if is on
                if( this.recognizing ) this.stopSpeechToText();
                
                if (speechSynthesis.speaking) {
                    // SpeechSyn is currently speaking, cancel the current utterance(s)
                    speechSynthesis.cancel();
                } else {
                    // Good to go
                    this.isSpeaking = true;
                    speech = this.speechReplaceSpecialCharsAndCommands(speech)
                    
                    var binding = new SpeechSynthesisUtterance(speech);
                    binding.lang = this.$root.$options.i18n.locale;
                    speechSynthesis.speak(binding);

                    binding.onend = () => {
                        if( this.isSpeaking) this.stopSpeech();
                    }
                }
            } else {
                this.stopSpeech();
            }
        },
        // Stop the speech synthesis
        // and reset the state
        stopSpeech() {
            this.isSpeaking = false;
            this.recognizing = false;
            // Stop voice reconigtion if is on
            this.toggleSpeechBar()
            // SpeechSyn is currently speaking, cancel the current utterance(s)
            speechSynthesis.cancel();
        },
        // Replace special characters in the speech text
        speechReplaceSpecialCharsAndCommands(speech) {
            let lang = this.$root.$options.i18n.locale;
            const rules = this.replacements[lang] || [];
            
            // Aplicar replacements en orden
            let processedSpeech = speech;
            rules.forEach(rule => {
                processedSpeech = processedSpeech.replace(rule.regex, rule.value);
            });
            
            return processedSpeech;
        },
        
        capitalizeAfterPunctuation(text) {
            // Mayúscula al inicio del texto
            text = text.replace(/^\s*\w/, (c) => c.toUpperCase());
            // Mayúscula después de punto, exclamación, interrogación o salto de párrafo
            text = text.replace(/([.!?]\s+|\n\n\s*)(\w)/g, (match, sep, char) => sep + char.toUpperCase());
            // Mayúscula después de comillas
            return text;
        }
    },

    mounted(){
        if( !this.recognition ) { this.SpeechRecognition(); }
    },
    created() {
        this.$root.$refs.MdTextSpeech = this;
    },
  }
</script>